import React, { useEffect, useState } from "react"
import {
  Col,
  Card,
  CardBody,
  Row,
  Nav,
  NavItem,
  NavLink,
  Table,
  Input,
  Label,
  Button
} from "reactstrap"
import { Link } from "react-router-dom"
import classnames from "classnames"
import PropTypes from 'prop-types';
//Simple bar
import SimpleBar from "simplebar-react"
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import * as url from "../../helpers/url_helper"
import { Config } from "helpers/backend_helper";

const TotalSellongProduct = props => {
  const [complaintData, setComplaintsData] = useState([])
  const [districtData, setDistrictData] = useState([])
  const [productionData, setProductionData] = useState({"months": [],"outflow":[],"inflow":[], "units":[]})

  useEffect(()=>{
    axios.get(url.DASHCOMPLAINTS, Config).then((r)=>{
      setComplaintsData(r.data)
    }).catch((e)=>{
      console.log(e)
    })
    axios.get(url.DASHCOMPLAINTSDISTRICTS, Config).then((r)=>{
      setDistrictData(r.data)
    }).catch((e)=>{
      console.log(e)
    })
    axios.get(url.DASHPRODUCTION, Config).then((r)=>{
      setProductionData(r.data)
    }).catch((e)=>{
      console.log(e)
    })
  },[])
  

  const options = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    colors: ["#556ee6", "#f1b44c"],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: "smooth",
      width: 5,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    xaxis: {
      categories: complaintData.map(item => item.month),
      title: {
        text: 'Year-Month',
      },
    },
    yaxis: {
      title: {
        text: 'Number of Complaints',
      },
    },
  };

  const series = [
    {
      name: 'Complaints',
      data: complaintData.map(item => parseInt(item.complaints, 10)),
    },
  ];

  const optionsD = {
    chart: {
      type: 'bar',
      stacked: 0,
      height: 350
    },
    xaxis: {
      categories: districtData && Object.keys(districtData)
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    legend: {
      position: 'top'
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (val) {
          return val ;
        }
      }
    }
  };

  const transposedData = {};
  const totals = [];
  Object.keys(districtData).forEach(month => {
    let monthTotal = 0;
    Object.keys(districtData[month]).forEach(letter => {
      const value = parseFloat(districtData[month][letter]);
      monthTotal += value;
      if (!transposedData[letter]) {
        transposedData[letter] = [];
      }
      transposedData[letter].push(value);
    });
    totals.push(monthTotal);
  });

  let seriesD = Object.keys(transposedData).map(letter => ({ name: letter, type: 'column', data: transposedData[letter]}));

  const seriesp = [
    /*{
      name: 'In-Flow',
      type: 'line',
      data: productionData.inflow.map(item => parseInt(item, 10)),
    },*/
    {
      name: 'Out-Flow',
      type: 'line',
      data: productionData.outflow.map(item => parseInt(item, 10)),
    },
    {
      name: 'Power',
      type: 'line',
      data: productionData.units.map(item => parseInt(item, 10)),
    },
  ];
  
  const optionsp = {
    chart: {
      height: 300,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    colors: ["#1a75ff","#ff471a"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: [5,5,3]
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        endingShape: 'rounded'
      }
    },
    markers: { size: 4, style: "hollow" },
    xaxis: {
      categories: productionData.months.map(item => item),
      title: {
        text: 'Month/Year',
      },
    },
    yaxis: [
      {
        
        title: {
          text: 'cu.m',
          style: {
            color: '#008FFB',
          }
        },
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: '#008FFB'
        },
        labels: {
          style: {
            colors: '#008FFB',
          }
        },
      },
    {
      title: {
        text: 'kWh',
        style: {
          color: '#ff471a',
        }
      },
      axisTicks: {
        show: true,
      },
      axisBorder: {
        show: true,
        color: '#ff471a'
      },
      series:'kWh',
      labels: {
        style: {
          colors: '#ff471a',
        }
      },
    },]
  };
  return (
    <React.Fragment>
      <Col xl="8">
      <Card>
          <CardBody>
            <div className="d-flex flex-wrap">
              <h5 className="card-title me-2">Customer Complaints</h5>
              
            </div>

  

            <hr className="mb-4" />
            <div id="area-chart" dir="ltr">
              <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={480}
                className="apex-charts"
              />
            </div>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="d-flex flex-wrap">
              <h5 className="card-title me-2">Complaints By Districts</h5>
              
            </div>
            <hr className="mb-4" />
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
           
                <div id="overview-chart-timeline">
                  <ReactApexChart options={optionsD} series={seriesD} type="bar" height={350} />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="d-flex flex-wrap">
              <h5 className="card-title me-2">Water Pumped from Geed Deeble</h5>
              
            </div>
            <hr className="mb-4" />
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
           
                <div id="overview-chart-timeline">
                  <ReactApexChart options={optionsp} series={seriesp} height={350} />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>

         <Card>
          <CardBody>
            <h4 className="card-title mb-4">Maintenance KPIs</h4>
            <div className="mt-4">
              <SimpleBar style={{ maxHeight: "440px" }}>
                <div className="table-responsive">
                  <table className="table table-nowrap align-middle table-hover mb-0">
                    <thead>
                    <tr>
                      <th>Name</th>
                      <th>Target</th>
                      <th>Actual</th>
                      </tr>
                    </thead>
                    <tbody>
                    {props.leave && props.leave.map((l,k)=>(
                      <tr key={k}>
           
                        <td style={{ width: "90px" }}>
                          <h5 className="text-truncate font-size-14 mb-1">
                              {l.leaveType}
                          </h5>
                        </td>
                        <td style={{ width: "50px" }}>
                          <h5 className="text-truncate font-size-14 mb-1">
                            {l.entitled}
                          </h5>
                        </td>
                        
                        <td style={{ width: "50px" }}>
                          <h5 className="text-truncate font-size-14 mb-1">
                            {l.balance}
                          </h5>
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </SimpleBar>
            </div>
          </CardBody>
        </Card>

      
      </Col>
    </React.Fragment>
  )
}
TotalSellongProduct.propTypes = {
  leave: PropTypes.any,
  showReports: PropTypes.any
}
export default TotalSellongProduct
